import { RuleObject } from 'antd/es/form';
import _ from 'lodash';

export const isNumber = (value: any) => {
  if (typeof value === 'number' && !isNaN(value)) return true;
  return false;
};

export const validateInputNumber = (rule: RuleObject, value: any) => {
  if (!value) return Promise.resolve();
  return isNumber(value) ? Promise.resolve() : Promise.reject(new Error('Please enter number'));
};

export const cloneDeep = (object: any) => {
  return _.cloneDeep(object);
};
